export default "__VITE_ASSET__Cvs3FRIb__"